import React, { Dispatch, SetStateAction } from 'react';

import { StateLanguage } from '../../languages/config/StateLanguage';
import { removeTooltip } from '../../utils/tooltip.util';
import { removeUploadFile, uploadImg } from '../../scripts/file.load.script';

import imgDefault from '../../assets/themes/default.png';

export interface AppInputImageProps {
  image: {value: {name: string, size: number, type: string, view: string, file: any}, valid: {file: boolean, message: string}},
  setImage: Dispatch<SetStateAction<{value: {name: string, size: number, type: string, view: string, file: any}, valid: {file: boolean, message: string}}>>
};

const AppInputImage: React.FunctionComponent<AppInputImageProps> = ({image, setImage}) => {
  const {lang} = StateLanguage()

  const handleChangeImage = async (event: React.ChangeEvent <HTMLFormElement | HTMLInputElement>) => {
    setImage(await uploadImg(lang, event.target.files[0]))
    removeTooltip()
  }

  const handleRemoveImage = () => {
    setImage(removeUploadFile())
    removeTooltip()
  }

  return (
    <>
      <div className="image-input image-input-outline">
        <img src={image.valid.file && image.value.view.length > 0 ? image.value.view : imgDefault} alt={image.value.name} className="image-input-wrapper w-auto h-125px bgi-position-center" />
        <label className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow" data-kt-image-input-action="change" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-original-title={lang.labels.changeImage}>
          <i className="bi bi-pencil-fill fs-8"></i>
          <input type="file" name="image" accept=".png, .jpg, .jpeg" onChange={handleChangeImage} />
        </label>
        <span className={`btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow ${(!image.valid.file || image.value.view.length === 0) && "d-none"}`} data-kt-image-input-action="remove" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-original-title={lang.labels.removeImage} onClick={handleRemoveImage}>
          <i className="bi bi-x fs-2"></i>
        </span>
      </div>
      <div className="form-text text-justify">{lang.labels.allowedFileTypes}</div>
      <div className={`fv-plugins-message-container invalid-feedback ${image.valid.file && "d-none"}`}>
        <div data-field="document" data-validator="file">{image.valid.message}</div>
      </div>
    </>
  )
}

export default AppInputImage;
